import { FC } from "preact/compat";
import { format } from "date-fns";
import { CapacityHeaderProps } from "./interfaces";

const CapacityHeader: FC<CapacityHeaderProps> = ({ range }) => (
    <div className="flex h-[42px] items-center gap-x-4 border-b border-gray-100 px-4 text-[11px] font-semibold uppercase tracking-wider text-gray-400">
        <span className="w-[260px] shrink-0">Employee</span>
        {range && (
            <span className="flex-1">
                Occupied · {format(range.start, "d MMM")} –{" "}
                {format(range.end, "d MMM yyyy")}
            </span>
        )}
    </div>
);

export default CapacityHeader;
